import {WorkbookController as BaseWorkbookController} from '@mintdata-wsp/common/controllers/spreadsheet/WorkbookController';
import {IWSPMeshContext} from '@mintdata-wsp/wsp/controllers/visualDesigner/spreadsheet/contexts/MeshContext';
import {WspMeshContextImpl} from '@mintdata-wsp/wsp/controllers/visualDesigner/spreadsheet/contexts/WspMeshContextImpl';
import {controllers} from '@mintdata-wsp/wsp/controllers/WspControllers';
import {SheetId} from '@mintdata/mint-kit/api/models/Identifiers';
import bind from 'bind-decorator';

export class WorkbookController extends BaseWorkbookController
{
    @bind
    public getMeshContextBySheetId(sheetId:SheetId, isNested:boolean = false):IWSPMeshContext
    {
        const result = controllers.ui.spreadsheets.main.findAnySheetByIdWithItsMainSheetId(sheetId, true);
        if( !result || !result.sheet )
            return null;

        const {sheet, mainSheetId} = result;

        if( sheet.isCloud )
        {
            throw new Error('Cloud sheets are not currently supported');
            // return new WspMeshContextCloudImpl(sheet.workbook.id, mainSheetId, sheetId, isNested);
        }

        return new WspMeshContextImpl(sheet.workbook.id, mainSheetId, sheetId, isNested);
    }
}
